import React from "react";
import { useSelector } from "react-redux";

export default function Footer({type, totalPriceValue}) {
  const paymentMethodId = useSelector((state) => state.rootReducer.scheduleSlice.sendData?.payment_method_id);
  const paymentBrand = useSelector((state) => state.rootReducer.scheduleSlice.sendData?.payment_brand);
  const paymentList = useSelector((state) => state.rootReducer.techsbookSlice.paymentList);
  const accountData = useSelector((state) => state.rootReducer.techsbookSlice.userData);
  const selectedMethod = paymentList?.find((p) => p.id === paymentMethodId);
  const cardBrand =
    paymentBrand ?? selectedMethod?.payment_method_data?.brand ?? "visa";
  const last4 = selectedMethod?.payment_method_data?.last4;
  return (
    <div className="payment__footer">
      {type ? (
        <div className="payment__footer-card">
          <div className="type">{cardBrand}</div>
          <div className="number">
            •••• •••• •••• {last4}
          </div>
        </div>
      ) : (
        <div className="payment__footer-card">
          <div className="type"><img src="/assets/icons/afirm.svg" alt=""/> Affirm</div>
        </div>
      )}
      <div className="payment__footer-total">
        <div>
          Total <span>{accountData?.country_currency_sign}{totalPriceValue}</span>
        </div>
      </div>
    </div>
  );
}
